import React from "react";
import { MessageOutlined } from "@ant-design/icons";
import type { ReactNode } from "react";

export type ConditionView = "keywords" | "numbers" | "countries" | "schedule" | "other";

/** Maps API condition codes to internal view types for form rendering */
export const CONDITION_CODE_TO_VIEW: Record<string, ConditionView> = {
    "Condition.Message.KeywordMatch": "keywords",
    "Condition.Number.NumberMatch": "numbers",
    "Condition.Location.Countries": "countries",
    "Condition.Time.RunSchedule": "schedule"
};

/** Maps API condition codes to node display titles */
export const CONDITION_CODE_TO_TITLE: Record<string, string> = {
    "Condition.Message.KeywordMatch": "Keywords",
    "Condition.Number.NumberMatch": "Number Match",
    "Condition.Location.Countries": "Countries",
    "Condition.Time.RunSchedule": "Run Schedule"
};

export function conditionCodeToTitle(code: string | undefined): string | undefined {
    return code ? CONDITION_CODE_TO_TITLE[code] : undefined;
}

/** Icon and style per condition code (for picker and nodes) */
const CODE_ICON_MAP: Record<string, { icon: ReactNode }> = {
    "Condition.Message.KeywordMatch": {
        icon: React.createElement("div", { className: "automationIconsSprite keyword-match-icon" }),
    },
    "Condition.Number.NumberMatch": {
        icon: React.createElement("div", { className: "automationIconsSprite number-match-icon" }),
    },
    "Condition.Location.Countries": {
        icon: React.createElement("div", { className: "automationIconsSprite countries-icon" }),
    },
    "Condition.Time.RunSchedule": {
        icon: React.createElement("div", { className: "automationIconsSprite run-schedule-icon" }),
    }
};

export function getConditionIconAndClass(code: string): { icon: ReactNode; } {
    return CODE_ICON_MAP[code] ?? { icon: React.createElement(MessageOutlined)};
}

export function conditionCodeToView(code: string): ConditionView {
    return CONDITION_CODE_TO_VIEW[code] ?? "other";
}
